export const isHelpdeskExternal = (p) => Number(p) === 3 || Number(p) === 4;

export const canCreateSupportTicket = (p) => Number(p) === 1;

export const canCreateTrainingTicket = (p) => Number(p) === 1 || Number(p) === 4;

export const canCreateAnyTicket = (p) =>
  canCreateSupportTicket(p) || canCreateTrainingTicket(p);
